/** @param {number} zoom */
export function attachmentImageGalleryMainImageSx(zoom) {
  return {
    transform: `scale(${zoom})`,
    transformOrigin: 'center center',
  }
}
